import type { SystemHealth } from '@isg/shared-types';
import { systemHealthSchema } from '@isg/validation';

/**
 * API yanıtı ağ kenarında doğrulanır. Sunucu sözleşmeyi bozarsa hata
 * ekranın ortasında değil, tam burada çıkar.
 */
export async function fetchHealth(signal?: AbortSignal): Promise<SystemHealth> {
  const response = await fetch('/api/health', { signal });
  if (!response.ok) {
    throw new Error(`API ${response.status} döndü`);
  }
  return systemHealthSchema.parse(await response.json());
}
